<template>
  <!-- Importing Change Password Component -->
  <ChangeSettingsComp></ChangeSettingsComp>
</template>
<script>
import ChangeSettingsComp from "../../components/Auths/ChangeSettings.vue";

export default {
  name: "User Setings Change",
  components: { ChangeSettingsComp },
  computed: {},
  mounted() {},
};
</script>
